import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import * as api from './api';
import { GetPointsPayload, GetPointsResponse } from './types';

export const TypePointGate = createGate<GetPointsPayload>();

const fxGetList = createEffect<GetPointsPayload, GetPointsResponse, Error>().use(
  api.getList
);

export const typePointQuery = createQuery({
  name: 'get-levels-entity',
  effect: fxGetList,
  mapData: ({ result }) => {
    if (Array.isArray(result) && result.length > 0) {
      return result.map(({ value, title: label, compl_type_id }) => ({
        id: value,
        label,
        compl_type_id,
      }));
    }
    return [];
  },
});

cache(typePointQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

sample({
  clock: TypePointGate.state,
  filter: filterByPointsGate,
  target: typePointQuery.start,
});

function filterByPointsGate({
  complex_id,
  buildings_id,
  compl_type_id,
}: GetPointsPayload): boolean {
  return Boolean(complex_id) || Boolean(buildings_id) || Boolean(compl_type_id);
}
